import React from 'react';
import { CompletionContainer } from '../../../../components/shared';
import { DefaultLoadingComponent } from '../default-loading-component';
export var LoaderForDialog = function () {
    return (React.createElement(CompletionContainer, { heading: React.createElement(DefaultLoadingComponent, { width: '30%' }), text: React.createElement(DefaultLoadingComponent, { width: '40%' }) },
        React.createElement(DefaultLoadingComponent, { loaderComponentProps: { height: '2.5rem' }, loaderContainerProps: { style: { width: '100%' } } })));
};
